/** Route-slot activity feed enums, mirroring the crm-core RouteSequenceEventType / RouteSequenceType. */

// A re-date or change-day arrives as an UNASSIGN + ASSIGN pair, so no compound types exist.
export const ROUTE_ACTIVITY_EVENT_TYPE = {
  ASSIGN: 'ASSIGN',
  UNASSIGN: 'UNASSIGN',
  SEQUENCE: 'SEQUENCE',
} as const

export const ROUTE_SEQUENCE_TYPE = {
  MASTER: 'MASTER',
  DAILY: 'DAILY',
} as const

export type RouteActivityEventType = typeof ROUTE_ACTIVITY_EVENT_TYPE[keyof typeof ROUTE_ACTIVITY_EVENT_TYPE]

export type RouteSequenceType = typeof ROUTE_SEQUENCE_TYPE[keyof typeof ROUTE_SEQUENCE_TYPE]
